export default "__VITE_PUBLIC_ASSET__06ca0c0d__"